<template>
<v-app light div id="app">

<transition name="fade" mode="out-in">
<keep-alive include="Home">
    <router-view></router-view>
    <!-- This seemed to cause perf probs <router-view :key="$route.fullPath"></router-view> -->
</keep-alive>
</transition>
<!-- <div class="pa-3 full-width center-text light-text small-text">You are logged in as ***** to *****</div> -->

<!-- <div style="text-align:center;background-color:#bbb;color:white;padding:3px">{{officeName}}</div> -->

<v-dialog max-width="300" v-model="loginDialogVisible" :fullscreen="$vuetify.breakpoint.xsOnly" transition="v-fade-transition" persistent>
<v-card>
<div style="height:300px">

    <v-card-text>
        <div v-if="showLoginButton" class="center-text">
            <div style="font-size:1.2em;padding-bottom:10px">Sign In</div>
            <v-divider style="margin-bottom:10px"></v-divider>
            <p>Holy guacamole. You need to be signed in to access this page</p>
            <img style="width:120px;margin-bottom:10px" src="/static/images/taco.jpg" />

            <v-btn @click.native="signIn" :disabled="!loginEnabled" class="primary">
                Login with Google
            </v-btn>
        </div>
        <div v-if="showSigningIn" style="padding-top:120px" class="center-text">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular> <br/>
            Signing In...
        </div>
    </v-card-text>

</div>
</v-card>
</v-dialog>

<v-snackbar bottom :timeout="alert.timeout" v-model="alert.visible" @click="clearAlert">
        {{ alert.message }}
        <v-btn v-if="alert.button" text dark>Got It</v-btn>
</v-snackbar>
<ChatWindow v-if="isChatting"/>
<EmailIndicator ref="emailIndicator"/>

<ConfirmDialog ref="confirm"></ConfirmDialog>
<YouTubeDialog ref="youtube"></YouTubeDialog>
<FormDialog ref="formDialog"></FormDialog>

</v-app>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import {format} from 'date-fns'

import ContactHelpers from './helpers/ContactHelpers'
import AlertHelpers from './helpers/AlertHelpers'
import AppHelpers from './helpers/AppHelpers'
import DataHelpers from './helpers/DataHelpers'
import { dateFormats } from './helpers/DateHelpers'
import ChatWindow from './ui-elements/ChatWindow'
import EmailIndicator from './ui-elements/EmailIndicator'
import ConfirmDialog from './ui-elements/ConfirmDialog'
import YouTubeDialog from './ui-elements/YouTubeDialog'
import FormDialog from './ui-elements/FormDialog'
import PageHelpers from './helpers/PageHelpers'



var db = firebase.database()

export default {

name: 'app',

data () {
    return {
        loginStatus: "Unknown",
        loginEnabled: true,
    }
},

components: {
    ChatWindow,
    ConfirmDialog,
    YouTubeDialog,
    EmailIndicator,
    FormDialog,
},

methods: {

    signIn(){
        console.log('signing in')

        this.loginEnabled = false

        this.$store.commit('loginStatus', "Signing In")

        let provider = new firebase.auth.GoogleAuthProvider()
        provider.addScope('email')
        provider.addScope('profile')
        // provider.addScope('https://www.googleapis.com/auth/gmail.send')
        // above causes warning
        provider.setCustomParameters({
            prompt: 'select_account'
        })

        // firebase.auth().signInWithRedirect(provider)
        firebase.auth().signInWithPopup(provider)
    },

    clearAlert() {
        AlertHelpers.clearAlert()
    },

    usersOfficesToArray(user) {
        let offices = []
        for(let officeKey in user.offices) {
            let office = {...user.offices[officeKey]}
            office.meta = {
                key:officeKey,
                userKey: user.uid
            }
            offices.push(office)
        }
        return offices
    },


},

computed: {
    isChatting() {
        return PageHelpers.getPageData('isChatting')
    },
    officeName() {
        return DataHelpers.officeName()
    },
    userName() {
        if(this.$store.getters.user)
            return ContactHelpers.fullName( this.$store.getters.user)
        else
            return 'Not Signed In'
    },
    userPicture() {
        if(this.$store.getters.user && this.$store.getters.user.image)
            return this.$store.getters.user.image
        else
            return ''
    },
    loginDialogVisible() {
        return this.loginStatus != 'Signed In'
            && this.$route.name != 'LivingExpenses'
            && this.$route.name != 'ClientChecklist'
            && this.$route.name != 'PrivacyPolicy'
            && this.$route.name != 'OneInvoice'
            && this.$route.name != 'Policies'
    },
    showLoginButton() {
        return this.loginStatus == 'Signed Out'
    },
    showSigningIn() {
        return this.loginStatus == 'Signing In'
    },

    alert() {
            return this.$store.getters.alert
    },
    alertMessage() {
        return this.$store.getters.alert.message
    },
    officName() {
        return DataHelpers.preferredOffice().name
    }
},

created() {

    this.loginStatus = this.$store.getters.loginStatus

    let vm = this
    firebase.auth().onAuthStateChanged(function (googleUser) {
        console.log('Google user is ', googleUser)
        if(googleUser){
            //global event can be subscribed by this.$on('signed-in', fn())
            vm.$eventBus.$emit('signed-in')

            //if logging in for first time, we take user from google auth user
            vm.$store.commit('loginStatus', "Signed In")

            vm.loginStatus = "Signed In"

            db.ref('users').child(googleUser.uid).once('value', function(snap) {

                let user = snap.val()

                if(user && user.office) {

                    vm.$store.commit('setUser', {
                        firstName: user.firstName || null,
                        lastName: user.lastName || null,
                        uid: user.uid || null,
                        image: user.image || null,
                        office: user.office || null,
                        email: user.email || null,
                        mobile: user.mobile || null
                    })

                    vm.$store.commit('setOffices', vm.usersOfficesToArray(user))
                    DataHelpers.initialiseTenant(user.office.key, true)
                    vm.$store.commit('setTenantDefault', user.office)

                    if(vm.$route.name == 'Welcome') {
                        console.log('Already signed in')
                        vm.$router.push('/home')
                    }
                } else {
                    let userContact = ContactHelpers.contactFromUser(googleUser)
                    vm.$store.commit('setUser', userContact)
                    vm.$router.push('/join')
                }

            })
        }
        else {
            vm.loginStatus = "Signed Out"
            vm.$store.commit('loginStatus', "Signed Out")
            vm.$store.commit('setUser', {})
        }
    })



    Number.prototype.between = function(a, b, inclusive = true) {
        var min = Math.min.apply(Math, [a, b]),
            max = Math.max.apply(Math, [a, b]);
        return inclusive ? this >= min && this <= max : this > min && this < max
    }
    String.prototype.append = function(str, delimiter = ' ') {
        //needs to be tested
        let newString = this
        if(newString && str)
            newString += delimiter
        if(str)
            newString += str

        return newString
    }

    String.prototype.contains = function(str) {
        if(!this)
            return false
        if(!str)
            return true

        let outerString = this.toLowerCase()
        let innerString = str.toLowerCase()
        return (outerString.indexOf(innerString) > -1)
    }

    String.prototype.wrap = function(prefix, suffix) {
        if(!this)
            return ''
        return (prefix || '') + this + (suffix || '')
    }

    Date.prototype.formatBackwards = function() {
        return format(this, dateFormats.BACKWARDS)
    }

    //window.addEventListener('beforeunload', this.exiting)

},

mounted() {
    this.$root.$youTube = this.$refs.youtube.open
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$monitorMail = this.$refs.emailIndicator.show
    this.$root.$dialog = this.$refs.formDialog.open
},

watch: {
    'loginDialogVisible': function(newVal) {
        if(newVal)
            this.loginEnabled = true
    }
},

beforeDestroy() {

}

}

</script>

<style>
/* Fix for google chart label flickering */
svg > g > g:last-child { pointer-events: none }

/* Center google chart on RangeChart page */
.g-chart > div > div {
    margin: 0 auto;
}

html, body {
    font-family: Roboto, sans-serif
}

td {
    vertical-align: top;
}

em {
    font-style: normal;
    font-weight: 900;
    background-color: rgba(244, 208, 63, .5)
}

.transparent-checkers {
    background-image: url(/static/images/transparent-checkers.png);
    background-repeat: repeat;
}

.white-background {
    background-color: white
}

.light-background {
    background-color: #f0f0f0;
}

.white-border {
    border: solid 2px white;
}

.inline-block {
    display: inline-block;
}

.margin-left-auto {
    margin-left:auto;
}

.no-focus:focus {
    outline: none;
}

.xray div {
    border:dotted 2px rgba(248, 2, 2, 0.24);
    background-color: rgba(0,0,0,0.02)
}

.light-placeholder input::placeholder {
    color: #cfcfcf!important;
}

.shadow {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
}

.raised {
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
}

.no-wrap {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow:hidden;
}

.display-block {
    display:block;
}

.display-flex {
    display:flex;
}
.flex-grow {
    flex-grow: 1;
}

.small-text {
    font-size:11px;
    font-weight:200
}
.light-text {
    color: #888;
}

.border-grey {
    border: solid 1px #c0c0c0
}

.border-transparent {
    border: solid 1px transparent;
}

.heading {
    color:#1976d2;
    font-size:20px;
    font-weight:400;
    letter-spacing: 0.02em;
}

.uppercase {
    text-transform: uppercase;
}

.heading-button {
    border-radius:20px;padding:4px 8px;
    transition: background-color 0.5s ease;
}

.heading-button:hover{
    background-color:rgba(255,255,255,0.1)
}

.section-heading {
    padding:4px 8px;color:white;background-color: #aaa;font-weight:600;
    border-radius:5px;text-transform: uppercase;
}


.section-heading.hoverable:hover {
    background-color:#999;
}


.vertical-margin {
    margin:10px 0px;
}

.inset-text{
    padding: 3px 0px 3px 10px;
    border-left: solid 4px #bbb;
    color: #555
}

.quick-input {
    padding:4px;
    padding-left:7px;
    border: solid 1px #c0c0c0;
    border-radius:3px;
    width: 100%
}

.strike-through {
    text-decoration: line-through;
}

.strike-through > i {
    display:none;
}

.list-tile {
    padding: 8px 12px;
    border: solid 1px #bbb;
    margin:5px;
}

.div-button {
    border: solid 1px #ccc;
    padding:6px 12px 6px 12px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
    background-color: rgba(0,0,0,0.02)
}

.div-button.rounded {
    height:44px;width:100%;border-radius:22px;padding-left:6px;
}

.rounded {
    border-radius: 5px;
}

.div-button:hover {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
    background-color: rgba(0,0,0,0.04)
}
.div-button:active {
    box-shadow: 0 0px 1px 0 rgba(0, 0, 0, 0.12);
}

.blue-hilight {
    background-color: #A9E2F3!important;
    border: solid 1px rgb(112, 184, 255)!important;
    box-shadow: 0 0 5px rgb(48, 132, 216);
}
.blue-hilight:hover {
    background-color: rgb(145, 216, 238)!important;
}

.glow-hover:hover {
    background-color: #A9E2F3;
    border: solid 1px rgb(130, 192, 253);
    box-shadow: 0 0 15px rgba(23, 124, 224, 0.904);
}

.subtle-shadow {
    border: solid 1px rgb(189, 186, 186);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.4);
    margin:5px;
}

.label {
    padding:2px 5px 2px 5px; border-radius:3px;
    color:white;font-weight:bold;
    margin-left:4px;font-size:0.85em;white-space:nowrap
}

.element-label{
    font-size:12px;
    color: #666;
}

.input-label {
    font-size:12px;
    color: rgba(0,0,0,0.6)
}

.round {
    border-radius:50%;
}

.center {
    margin:auto;
}

.center-text {
    text-align: center
}

.full-width {
    width:100%;
    margin-left:0;
    margin-right:0;
}

.no-margin {
    margin:0
}

.no-padding {
    padding:0!important
}
.no-padding .v-list {
    padding:0!important
}

.padding-wide {
    padding: 8px 15px;
}

.clickable {
    user-select: none;
    cursor: pointer;
}

.text-selectable {
    user-select: text!important;
    cursor: text;
}

.show-on-hover {
    opacity: 0.3;
    transition: opacity 0.5s ease-in-out;
}

/* Hover on desktop only */

@media(hover:hover) {
    .hoverable:hover {
        background-color:rgba(0,0,0,.05)!important;
        /* background-color:#f5f5f5!important; */
    }

    .show-on-hover {
        opacity: 0;
    }

    .hover-container:hover .show-on-hover {
        opacity: 1;
    }

}



/* Selectable Lists */
.selectable {
    border: solid 1px transparent;
    transition: all .3s ease-in-out;
}

.indicator {
    padding:5px 3px 5px 9px;
    border-left: solid 4px transparent;
    transition:all .3s ease-in-out;
}

.selectable.important .indicator {
    border-left: solid 4px #1c75d2;
}

.selectable .menu-icon {
    color: transparent;
}

.selectable:hover .menu-icon {
    color: #999;
}

.selectable.selected .menu-icon {
    color: #888;
}

.selectable.selected {
    border: solid 1px #bbb;
    background-color: #ddd;
}

.selectable.selected.hoverable:hover {
    background-color: #ccc !important
}

/* End */

.glow-text {
    text-shadow: 1px 1px 3px #228DFF
}

.debug {
    margin:2px;
    border: solid 1px rgb(250, 130, 130);
    background-color: rgb(250, 202, 218);
}

.transparent {
    text-decoration:none;
    color: inherit!important;
}

.truncate {
    overflow:hidden; white-space:nowrap; text-overflow: ellipsis;
}

.no-border {
    border:none;
}

.no-border:focus{
    outline:none;
}

.v-icon--link {
    outline: none!important
}

.v-btn:focus {
    outline:none!important
}

.no-border-text {
    padding:5px;border: solid 0px #888; color:#333; width:100%
}

.no-select {
-webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
/* CSS Transition */
@keyframes fadeIn { from { opacity:0;} to { opacity:1; } }

.fade-in-only {
    opacity:0;
    animation:fadeIn ease-in 1s;
    animation-delay: 0s;
    animation-fill-mode:forwards;
}

/* Vue Transitions */

.expand-transition {
  transition: all .9s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}

.expand-fade-enter-active, .expand-fade-leave-active {
  transition: all .5s ease-in-out;
  max-height:400px;
}
.expand-fade-enter, .expand-fade-leave-to {
  opacity: 0;
  max-height:0
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .6s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

.x-slow-fade-enter-active, .x-slow-fade-leave-active {
  transition: opacity 3.0s
}
.x-slow-fade-enter, .x-slow-fade-leave-to {
  opacity: 0
}

.slow-fade-enter-active, .slow-fade-leave-active {
  transition: opacity 1s
}
.slow-fade-enter, .slow-fade-leave-to {
  opacity: 0
}

.expand-trick-enter-active, .expand-trick-leave-active {
  transition: height .2s ease-in-out;
  transition: opacity .5s ease-in-out;
  max-height:300px;
  opacity:1
}
.expand-trick-enter, .expand-trick-leave-to {
    max-height:0;
    opacity:0;
}

/* .pulse-enter-active, .pulse-leave-active {
  transition: opacity .5s
}
.pulse-enter, .pulse-leave-to {
  border: solid 1px green
} */

.list-complete-item {
  transition: all 1s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active for <2.1.8 */ {
  background-color:yellow;
  opacity: 0;
  transform: translateX(-30px);
}
.list-complete-leave-active {
  /*position: absolute;*/
}

.flip-list-move {
  transition: transform 1s;
}

.no-border { border: none!important}

.title-column {
    padding-right:5px; text-align: right; font-weight: bold; vertical-align: top;
}

/* CK Editor Overrides */

.ck-content {
    font-size:14px!important;
    max-height:300px;
    min-height:100px;
}

/* Vuetify Overrides */

    .blue-background .v-progress-circular__underlay {
        stroke:none;
        /* stroke: rgba(25,118,210,.1)!important; */
    }

    .v-card.v-picker--flat {
        box-shadow: none!important;
    }

    /* Moved to home.vue local file...Fix for Safari dialog display. Reference Vuetify issue #2111  */
    /* .menuable__content__active {z-index:250!important; } */
    .active-list-item .v-list__tile__title {
        color:#1c75d2;
    }

    .selectable .v-list-item {
        border: solid 1px transparent;
    }

    .selectable .v-list-item.active {
        background-color:rgba(130, 192, 253, 0.1);
        border: solid 1px rgba(130, 192, 253, 0.5);
    }

    .clickable .v-chip__content {
        cursor: pointer;
    }

    th.column.sortable i {
        margin-left:4px;
    }

    .v-progress-circular.solid .v-progress-circular__underlay {
        stroke:#ccc;
    }

    /* Checkbox List - Condense Spacing */
    .checkbox-list.v-input--checkbox { margin-top:0px }
    .checkbox-list .v-messages { display: none }
    .checkbox-list .v-input__slot { margin-bottom: 4px }

    .compact {
        margin:0!important
    }

    .compact .v-input--selection-controls {
        margin:0;padding:0
    }

    .v-input.compact{
        padding-top:0
    }

    /* bullets were showing hidden in editor */
    .vue-html5-editor .content li {
        margin-left:15px!important
    }

    .input-group--slider.compact {
        padding-top: 0px!important;
        margin-top: -30px!important;
    }

    .input-group--text-field.compact {
        padding: 0px!important;
    }

    /* Radio buttons label is too big */
    .v-input--radio-group legend.v-label {
        font-size: 12px;
    }

    /* Toggle buttons text smaller when dense */
    .v-btn-toggle--dense button {
        font-size:12px!important
    }
    .v-btn-toggle--dense i {
        font-size:18px!important;
        opacity:.8
    }

    /* Dropdown list clear button smaller */
    .v-select__slot .mdi-close {
        color:#AAA!important;
        font-size:16px!important;
    }

    .input-group--slider label{
        font-size: 16px!important;
        color:#555555!important;
    }

    /* text field in activity */
    .activity-outer input {
        color:#555555!important;
        font-size:15px!important;
    }

    .activity-outer label {
        color: #888!important;
        font-size:14px!important;
    }

    .activity-outer .input-group__input {
        font-size: 15px!important
    }

    /* dropdown in activity */
    .activity-outer .input-group__selections__comma {
        color:#555555!important;
        font-size:14px!important;
    }

    .input-group__hint {
        color:#999999!important;
        font-size:11px!important;
        margin-top:5px
    }

    .application--light .input-group--slider:not(.input-group--dirty).input-group--ticks .slider__thumb-container .slider__thumb {
        background-color: #c0c0c0
    }

    /* vuetify sets content to flex, so emails format wrong */
    .vue-html5-editor > .content {
        display:block!important
    }

    /* In dev, lists were showing in blue */
    .list__tile {color:#333!important}

    /* .input-group--hide-details {
        margin-top:5px;margin-bottom:5px;
    } */

    span.fa.icon {
        font-size: 16px;
    }

    /* HTML Editor Overrides */

    .vue-html5-editor>.toolbar {
        box-shadow: none;
    }

    .vue-html5-editor>.dashboard-font {
        font-size:14px!important;
    }

    .vue-html5-editor>.toolbar>.dashboard button {
        font-weight:normal;
        font-size:12px;
    }

    .vue-html5-editor>.toolbar>ul{
        padding-bottom:2px!important
    }

    /* Quill Overrides to make full height  */

    #quill-container {
        flex-grow:1;
        overflow-y:hidden;

    }
    .ql-editor {
        min-height: 10px!important;
    }

    /* dialogs */

    .dialog-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        background-color: white;
    }

    .dialog-header {
        flex-shrink: 0;
    }
    .dialog-body{
        flex-grow: 1;
        overflow: auto;
        min-height: 2em;
    }

    .dialog-footer{
        flex-shrink: 0;
        padding:12px;
        text-align:right;
        width:100%
    }

    /* Vue Popper Js Overrides */
    .popper.taco-popper {
        padding:15px;
        box-shadow: 0 0 24px 5px rgba(0,0,0,0.2);
        border: 1px solid #c0c0c0;
    }
    .popper[x-placement^="top"] .popper__arrow {
        border-width:10px 10px 0 10px!important;
        bottom: -10px!important;
    }
    .popper[x-placement^="bottom"] .popper__arrow {
        border-width:0px 10px 10px 10px!important;
        top: -10px!important;
    }

    /* Vue Dialog Overrides */

    .dg-backdrop {
        background-color: rgba(0,0,0,.4);
    }

    .dg-main-content {
        font-family: 'Arial'
    }

    .print-only {
        display:none;
    }

    @keyframes yellowfade {
        from {
            background: #FFCCBC;
        }
        to {
            background: transparent;
        }
    }

    .item-pulse {
        animation: yellowfade 1s;
    }

@keyframes shadow-pulse
{
     0% {
          box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.15);
     }
     20% {
          box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
     }
     100% {
          box-shadow: 0 0 0 0px rgba(0, 0, 0, 0);
     }
}
.shadow-pulse
{
     animation: shadow-pulse 5s infinite;
}

@keyframes blue-pulse
{
     0% {
          box-shadow: 0 0 0 0px rgba(0,115,230, 0.25);
     }
     20% {
          box-shadow: 0 0 0 20px rgba(0,115,230, 0);
     }
     100% {
          box-shadow: 0 0 0 0px rgba(0,115,230, 0);
     }
}
.blue-pulse
{
     animation: blue-pulse 5s infinite;
}

@media print
{
    .vue-html5-editor.full-screen {
        border:none!important;
    }

    .vue-html5-editor > .toolbar {
        visibility: hidden;
    }

    .no-print-border {
        border:none!important;
        box-shadow:none!important;
    }

    /* Hack because vuetify uses important on their elevations */
    div.elevation-1.no-print-border {
        border:none!important;
        box-shadow:none!important;
    }

    .no-print, .no-print *
    {
        display: none!important;
    }
    .print-only {
        display: inline-block;
    }

    .hide-print, .hide-print * {
        visibility:hidden;
    }

    .show-print, .show-print * {
        visibility: visible!important;
        overflow-y:visible!important;
        /* display:inline; */
    }
    .show-print {
        left:-7mm; top:-15mm;
    }

}

@media (min-width: 500px) {
  .flex-large {
        display:flex
  }
}

@media (min-width: 600px) {

    html, body, .v-application, .application--wrap {
        height:100%;
        overflow: hidden;
    }

    .full-height {
        height:100%;
        overflow: hidden;
    }

    .full-height-column {
        height:100%;
        float:left;
        min-width:100px;
        overflow:auto;
        padding:8px;
        box-sizing: border-box;
    }


    .taco-container {
        height: 100%;
        display:flex;
        flex-direction: column;
        overflow:auto;
    }


    .taco-content {
        flex:1;
        display:flex;
    }

    .taco-column {
        overflow-y:auto;overflow-x:hidden;
        flex:1
    }

}

/* Workflow Stuff */

.flow-layout {
    display:flex;
    background-color:#eee;
}

.flow-layout-main {

}

.flow-layout-right {
    display: none;
    position:fixed; top:46px;right:0px;left:0px;bottom:0px;background-color: #eee;
}

.columns-on-wide {
    display:flex;
}

.raised-desktop {
    border-radius:3px;
}

@media (min-width: 800px) {
  .flow-layout-main {
        /* margin-right:400px; */
  }
  .flow-layout-right {
      position:static;
      margin-top:0;
      display:block;
      flex-basis: 400px;
      width:400px;
  }
  .flow-step-expander {
      padding-left: 44px!important;
  }
  .raised-desktop {
      margin:10px;
      box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important
  }
}
@media (min-width: 1000px) {
    .flow-layout-main {
        /* margin-right:500px; */
    }
    .flow-layout-right {
      display:block;
      flex-basis: 500px;
      width:500px;
    }

    .raised-desktop {
        margin:15px;
        box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important
    }
}
@media (max-width: 500px) {
    .columns-on-wide {
        display: block;
    }
}




/* Flow layout 3 */

.flow-page {
    display:flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    background-color: #eee;
    position:relative;
}
.flow-title {
    flex-shrink: 1;
    border: solid 1px #bbb;
    padding:8px;
}
.flow-content {
    /* padding: 10px; */
    height:0;
    overflow: hidden;
    flex-grow: 1;
    flex-shrink: 1;
    display:flex;
    position: relative;
    justify-content: center;
    gap: 10px;
}
.flow-col {
    height: 100%;
    overflow-y:auto;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;

}
.flow-col-left {
    flex-basis: 0;
    visibility: hidden;
}
.flow-col-main {
    flex-basis: 700px;
    flex-shrink:1
}
.flow-col-right {
    flex-basis: 500px;
    flex-shrink:2;
}

.flow-panel-outer {
    padding:3px;
    margin-bottom: 10px;
    transition: all .5s ease-in-out;
}

.flow-panel {
    background-color: white;
    box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important;
    /* transition: box-shadow 1s ease-in-out; */
}

@media (max-width: 800px) {
    .flow-content {
        gap: 2px;
    }
    .flow-panel {
        box-shadow: 0;
    }
    .flow-panel-outer {
        padding:0;
    }
}
@media (min-width: 1280px) {
    .flow-content {
        gap: 15px;
    }
    .flow-col-left {
        visibility: visible;
        flex-basis: 300px;
    }
    .flow-panel-outer {
        padding:15px;
    }
}

</style>



// WEBPACK FOOTER //
// App.vue?20293b6b